export function isArray(a) {
   return Array.isArray(a);
}
